export default defineNuxtRouteMiddleware((to) => {
  const generalStore = useGeneralStore();
  const localePath = useLocalePathPolyfill();
  if (
    !generalStore.isAuthenticated &&
    !generalStore.guestOrderInfo &&
    (!to.query.email || !to.query.number || !to.query.billing_zip)
  ) {
    return navigateTo(localePath("/track-order"));
  }
});
